var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLink',{staticClass:"app-social",attrs:{"to":_vm.icon.url,"aria-label":_vm.ariaLabel,"ga-event":_vm.gaEvent}},[_c(_vm.iconComponentName,{tag:"Component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }